import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import NavPills from 'components/NavPills/NavPills';
import styles from 'assets/jss/material-kit-react/views/profilePage.js';
import BubbleContainer from 'components/BubbleContainer/BubbleContainer';
import useDocumentTitle from 'hooks/useDocumentTitle';
import SavedSearches from 'components/SavedSearches/SavedSearches';
import HowToUse from 'components/SavedSearches/HowToUse';
import { InfoOutlined, YoutubeSearchedForOutlined } from '@mui/icons-material';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';

const useStyles = makeStyles<Theme>((theme) => ({
  mainContainer: {
    position: 'relative',
    zIndex: 2,
    backgroundColor: theme.palette.background.paper,
    borderRadius: '6px',
    color: theme.palette.text.primary,
  },
  container: {
    ...styles.container,
    position: 'relative',
    zIndex: 3,
  },
  contentContainer: {
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    zIndex: 1100,
    '& .MuiTabs-root': {
      zIndex: 1200,
    },
    '& .MuiTab-root': {
      zIndex: 1200,
    },
  },
  card: {
    marginBottom: theme.spacing(2),
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
  },
  cardHeader: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textAlign: 'center',
  },
  cardBody: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    width: '100%',
  },
}));

export default function SavedSearchesPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  useDocumentTitle(t('navigation.savedSearches'));

  return (
    <div>
      <div className={classes.mainContainer}>
        <div className={classes.container}>
          <div className={classes.contentContainer}>
            <Card>
              <CardHeader color="primary">
                <h4>{t('navigation.savedSearches')}</h4>
              </CardHeader>
              <CardBody>
                <NavPills
                  queryKey={'t'}
                  alignCenter
                  fullWidth
                  onChange={function () {}}
                  color="primary"
                  tabs={[
                    {
                      tabName: 'saved',
                      tabButton: (
                        <>
                          {t('navigation.savedSearches')}{' '}
                          <YoutubeSearchedForOutlined
                            sx={{ fontSize: 16, verticalAlign: 'middle' }}
                          />
                        </>
                      ),
                      tabContent: <SavedSearches />,
                    },
                    {
                      tabName: 'howToUse',
                      tabButton: (
                        <>
                          {t('savedSearches.howToUse.title')}{' '}
                          <InfoOutlined sx={{ fontSize: 16, verticalAlign: 'middle' }} />
                        </>
                      ),
                      tabContent: <HowToUse />,
                    },
                  ]}
                />
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
      <BubbleContainer pageKey="savedSearches" helpText={t('help.savedSearches')} />
    </div>
  );
}
